"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductDetails = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const ramda_1 = require("ramda");
const attributes_1 = require("../../attributes");
const client_constants_1 = require("../../client.constants");
const gql_1 = require("../gql");
const attributes_2 = require("../../../constants/attributes");
const useProductDetails = ({ catalogId, productId, productTreeNodeId, skipMeasures = false, baseAttributes, }) => {
    const { data, loading, error, } = (0, react_2.useQuery)(gql_1.GET_PRODUCT_DETAILS, {
        variables: {
            catalog: catalogId,
            productIds: [productId],
            baseLabels: baseAttributes,
            skipMeasures,
        },
        notifyOnNetworkStatusChange: true,
    });
    const { data: strategyAttributesData, previousData: previousStrategyAttributesData, isLoading: isStrategyDataLoading, error: strategyDataError, } = (0, attributes_1.useGetStrategyAttributes)({
        productTreeNodeId,
        pageSize: client_constants_1.REQUEST_LIMIT_MAX,
        options: {
            skip: !productTreeNodeId,
        },
    });
    const strategyData = strategyAttributesData || previousStrategyAttributesData;
    const product = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!strategyData) {
            return null;
        }
        const product = (_b = (_a = data === null || data === void 0 ? void 0 : data.products) === null || _a === void 0 ? void 0 : _a.edges[0]) === null || _b === void 0 ? void 0 : _b.node;
        if (!product) {
            return null;
        }
        const { edges: validAttributionEdges } = product.validAttributions;
        const productEnrichedAttributeLabels = Array.from(new Set(validAttributionEdges.map(({ node }) => node.label)));
        const strategyAttributeLabels = strategyData.map(({ node }) => node.label);
        const missedStrategyAttributeLabels = (0, ramda_1.without)(productEnrichedAttributeLabels, strategyAttributeLabels);
        const notInStrategyProductAttributeLabels = (0, ramda_1.without)(strategyAttributeLabels, productEnrichedAttributeLabels);
        // remove product attributes that are not In Strategy
        const strategyProductAttributes = validAttributionEdges.filter(({ node }) => !notInStrategyProductAttributeLabels.includes(node.label));
        const unknownProductAttributions = missedStrategyAttributeLabels.map((label) => ({
            node: {
                label,
                value: attributes_2.SpecialAttributeValue.Unknown,
            },
        }));
        return Object.assign(Object.assign({}, product), { validAttributions: {
                edges: [
                    ...strategyProductAttributes,
                    ...unknownProductAttributions,
                ],
            } });
    }, [data === null || data === void 0 ? void 0 : data.products.edges, strategyAttributesData]);
    return {
        data: product,
        isLoading: loading || isStrategyDataLoading,
        error: error || strategyDataError,
    };
};
exports.useProductDetails = useProductDetails;
